// inspired by https://github.com/claudijo/react-2d-canvas/blob/main/utils/color-incrementer.js
export default class ColorIncrementer {
  step: number = 4;
  rgb: [number, number, number] = [0, 0, 0];
  reset() {
    this.rgb = [0, 0, 0];
  }

  next() {
    for (let index = 0; index < 3; index++) {
      if (this.rgb[index] + this.step < 256) {
        this.rgb[index] += this.step;
        return `rgb(${this.rgb.join(',')})`;
      } else if (index < 2) {
        this.rgb[index] = 0;
      }
    }

    throw new Error('Color incrementer overflow');
  }
}
